import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';
import { Modal } from "flowbite-react";
import DataTable from 'react-data-table-component';
import { FaEdit } from "react-icons/fa";
import Swal from 'sweetalert2';
import { BsFillPrinterFill } from "react-icons/bs";
import { ImCancelCircle } from "react-icons/im";
import { MdDelete, MdRestore } from "react-icons/md";
import { IoArrowBackOutline } from "react-icons/io5";

const EditAppointments = ({ doctor, onCancel }) => {

    const [selectedSchedule, setSelectedSchedule] = useState(null);
    const [rowPerPage, setRowPerPage] = useState(20);
    const [selectedDoctor, setSelectedDoctor] = useState(null);
    const [appointments, setAppointments] = useState([]);
    const [showTable, setShowTable] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [selectedFee, setSelectedFee] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showServiceInput, setShowServiceInput] = useState(false);
    const [editingServiceId, setEditingServiceId] = useState(null);
    const [editValues, setEditValues] = useState({ description: '', price: '' });
    const serviceInputRef = useRef(null);
    const [openModal, setOpenModal] = useState(false);
    const [details, setDetails] = useState([]);
    const [selectedDate, setSelectedDate] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [editFormData, setEditFormData] = useState({
        scheduleID: '',
        start_time: '',
        end_time: '',
        doctor_fee: '',
        patients: '',
    });
    const [formData, setFormData] = useState({
        doctor_id: doctor.id || '',
        available_from: '',
        available_to: '',
        week_day: '',
        start_time: '',
        end_time: '',
        doctor_fee: '',
        patients: '',
    });

    const customStyles = {
        headCells: {
            style: {
                backgroundColor: '#202643',
                color: 'white',
                fontWeight: 'bold',
                fontSize: '13px',
            },
        },
    };

    const handleOpenModel = (id, fee) => {
        setSelectedId(id);
        setFormData({
            ...formData,
            appointmentId: id,
        });
        setSelectedFee(fee);
        fetchServices(id);
        setOpenModal(true);
    };

    const filteredAppointments =
        startDate && endDate
            ? appointments.filter(app => {
                const appDate = new Date(app.schedule_date).toISOString().slice(0, 10);
                return appDate >= startDate && appDate <= endDate;
            })
            : appointments;


    const fetchAppointments = async () => {
        try {
            const response = await axios.get(`https://backend.amarasinghemedicare.com/appointment/appointments/doctor/${doctor.id}`);

            setAppointments(response.data);
            setShowTable(response.data.length > 0);
        } catch (error) {
            console.error("Error fetching appointments:", error);
            setError("Failed to fetch appointments.");
            setAppointments([]);
            setShowTable(false);
        }
    };

    function onCloseModal() {
        setShowServiceInput(false);
        setOpenModal(false);
    }

    useEffect(() => {
        fetchAppointments();
    }, [doctor]);

    const fetchServices = async (id) => {
        try {
            const response = await fetch(`https://backend.amarasinghemedicare.com/service/details?appointmentId=${id}`);
            const data = await response.json();

            if (response.ok) {
                setDetails(data);
            } else {
                console.error(data.message);
            }
        } catch (error) {
            console.error("Something went wrong", error);
        }
    };

    const handleViewDetails = (row) => {
        Swal.fire({
            title: `Patient Information`,
            html: `
                <div>
                    <h1><strong>Name:</strong> ${row.firstName} ${row.lastName}</h1>
                    <p><strong>Age:</strong> ${row.age || 'Not Available'}</p>
                    <p><strong>Gender:</strong> ${row.gender || 'Not Available'}</p>
                    <p><strong>Contact:</strong> ${row.mobileNo || 'Not Available'}</p>
                    <p><strong>NIC Number:</strong> ${row.nic}</p>
                    <p><strong>Appointment Time:</strong> ${row.timeSlot}</p>
                    <p><strong>Status:</strong> ${row.status || 'Not Available'}</p>
                    <div style="display: flex; justify-content: right; margin-top: 15px;">
                        <button id="editButton" class="swal2-confirm swal2-styled" style="background-color: #007BFF;">Edit</button>
                        <button id="cancelButton" class="swal2-cancel swal2-styled" style="background-color: #d33;">Cancel</button>  
                    </div>
                </div>
            `,
            icon: 'info',
            showConfirmButton: false, // Hide default close button
        });

        // Add an event listener to the Edit button
        setTimeout(() => {
            const editButton = document.getElementById("editButton");
            const cancelButton = document.getElementById("cancelButton");

            if (editButton) {
                editButton.addEventListener("click", () => handleEditDetails(row));
            }

            if (cancelButton) {
                cancelButton.addEventListener("click", () => {
                    Swal.close(); // Close the Swal popup
                });
            }
        }, 0);
    };

    const handleEditDetails = (row) => {
            const timeSlot = row.timeSlot;
    
            let startTime = '';
            let endTime = '';
    
            if(timeSlot){
                const times = timeSlot.split("-");
                startTime = times[0].trim();
                endTime = times[1].trim();
            }
    
            Swal.fire({
                title: "Edit Patient Details",
                html: `
                        <form id="editForm">
                            <div style="display: flex; flex-wrap: wrap; gap: 10px;">
                                <div style="flex: 1 1 45%;">
                                    <label style="font-size: 18px;"><strong>First Name:</strong></label>
                                    <input type="text" id="editFirstName" value="${row.firstName}" class="swal2-input" style="width: 70%; font-size: 16px; padding: 8px;"/>
                                </div>
        
                                <div style="flex: 1 1 45%;">
                                    <label style="font-size: 18px;"><strong>Last Name:</strong></label>
                                    <input type="text" id="editLastName" value="${row.lastName}" class="swal2-input" style="width: 70%; font-size: 16px; padding: 8px;"/>
                                </div>
                            </div>
                
                            <div style="display: flex; flex-wrap: wrap; gap: 10px;">
                                <div style="flex: 1 1 45%;">
                                    <label style="font-size: 18px;"><strong>Age:</strong></label>
                                    <input type="number" id="editAge" value="${row.age || ''}" class="swal2-input" style="width: 70%; font-size: 16px; padding: 8px;"/>
                                </div>
        
                                <div style="flex: 1 1 45%;">
                                    <label style="font-size: 18px;"><strong>Gender:</strong></label>
                                    <input type="text" id="editGender" value="${row.gender || ''}" class="swal2-input" style="width: 70%; font-size: 16px; padding: 8px;"/> 
                                </div>
                            </div>
                
                            <div style="display: flex; flex-wrap: wrap; gap: 10px;">
                                <div style="flex: 1 1 45%;">
                                    <label style="font-size: 18px;"><strong>Contact:</strong></label>
                                    <input type="text" id="editMobileNo" value="${row.mobileNo || ''}" class="swal2-input" style="width: 70%; font-size: 16px; padding: 8px;"/>
                                </div>
        
                                <div style="flex: 1 1 45%;">
                                    <label style="font-size: 18px;"><strong>NIC Number:</strong></label>
                                    <input type="text" id="editNic" value="${row.nic}" class="swal2-input" style="width: 70%; font-size: 16px; padding: 8px;"/>  
                                </div>
                            </div>
    
                            <label style="font-size: 18px; color: #97CE4F;"><strong>Appointment Details</strong></label>
                            <div style="display: flex; flex-wrap: wrap; gap: 10px;">
                                <div style="flex: 1 1 45%;">
                                    <label style="font-size: 18px;"><strong>Start Time:</strong></label>
                                    <input type="time" id="startTime" value="${startTime}" class="swal2-input" style="width: 70%; font-size: 16px; padding: 8px;"/>
                                </div> 
        
                                <div style="flex: 1 1 45%;">  
                                    <label style="font-size: 18px;"><strong>End Time</strong></label>
                                    <input type="time" id="endTime" value="${endTime}" class="swal2-input" style="width: 70%; font-size: 16px; padding: 8px;"/>
                                </div>
                            </div>
                
                            <div style="display: flex; flex-wrap: wrap; gap: 10px;">    
                                <div style="flex: 1 1 45%;">  
                                    <label style="font-size: 18px;"><strong>Status:</strong></label>
                                    <input type="text" id="editStatus" value="${row.status || ''}" class="swal2-input" style="width: 40%; font-size: 16px; padding: 8px;"/>
                                </div>
                            </div>
                        </form>
                    `,
                showCancelButton: true,
                confirmButtonText: "Update",
                cancelButtonText: "Cancel",
                preConfirm: () => {
                    const updatedRow = {
                        id: row.id, // Include ID for update
                        firstName: document.getElementById("editFirstName").value,
                        lastName: document.getElementById("editLastName").value,
                        age: parseInt(document.getElementById("editAge").value) || null, // Convert to integer
                        gender: document.getElementById("editGender").value,
                        mobileNo: document.getElementById("editMobileNo").value,
                        nic: document.getElementById("editNic").value,
                        startTime: document.getElementById("startTime").value,
                        endTime: document.getElementById("endTime").value,
                        status: document.getElementById("editStatus").value,
                    };
    
                    return fetch(`https://backend.amarasinghemedicare.com/appointment/appointments/update/${row.id}`, {
                        method: "PUT",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(updatedRow),
                    })
                        .then((response) => response.json())
                        .then((data) => {
                            if (data.message === "Appointment updated successfully") {
                                Swal.fire("Success", "Details updated successfully", "success").then(() => {
                                    fetchAppointments();
                                });
                            } else {
                                Swal.fire("Error", "Failed to update details", "error");
                            }
                        })
                        .catch((error) => {
                            console.error("Error updating details:", error);
                            Swal.fire("Error", "Something went wrong", "error");
                        });
                }
            });
        };

    const handleStatusChange = (event, id) => {
        const newStatus = event.target.value;

        // Update the status in the backend (this should be an API call)
        axios
            .put(`https://backend.amarasinghemedicare.com/appointment/appointments/update-status/${id}`, { status: newStatus })
            .then((response) => {
                toast.success('Status updated successfully', {
                    position: "top-center",
                });
                // You can also update the status in local state here
                const updatedAppointments = appointments.map((appointment) => {
                    if (appointment.id === id) {
                        return { ...appointment, status: newStatus };
                    }
                    return appointment;
                });
                setAppointments(updatedAppointments);
            })
            .catch((error) => {
                toast.error('Failed to update status', {
                    position: "top-center",
                });
            });
    };

    const columnsAppointments = [
        {
            name: '#', selector: (row, index) => index + 1, width: '60px', cell: (row, index) => (
                <span className={`${row.deleted_at ? 'opacity-50' : 'opacity-100'}`}>
                    {index + 1}
                </span>
            ),
            sortable: false,
        },
        {
            name: 'Patient Name', selector: row => `${row.firstName} ${row.lastName}`, sortable: true, cell: row => (
                <span
                    className={`${row.deleted_at ? 'opacity-50' : 'opacity-100'}`}
                >
                    {row.firstName} {row.lastName}
                </span>
            ),
        },
        {
            name: 'Sheet', selector: row => `${row.sheet_No}`, sortable: true, cell: row => (
                <span className={`${row.deleted_at ? 'opacity-50' : 'opacity-100'}`}>
                    {row.sheet_No}
                </span>
            ),
            sortable: false,
        },
        {
            name: 'Time', selector: row => row.timeSlot, sortable: true, cell: row => (
                <span
                    className={`${row.deleted_at ? 'opacity-50' : 'opacity-100'}`}
                >
                    {row.timeSlot}
                </span>
            ),
        },
        {
            name: 'Date', selector: row => new Date(row.schedule_date).toISOString().split('T')[0], sortable: true, cell: row => (
                <span
                    className={`${row.deleted_at ? 'opacity-50' : 'opacity-100'}`}
                >
                    {new Date(row.schedule_date).toISOString().split('T')[0]}
                </span>
            ),
        },
        {
            name: 'Fee',
            cell: row => (
                <div className="flex items-center justify-center space-x-3">
                    <button
                        onClick={() => handleOpenModel(row.id, row.fee)}
                        disabled={row.deleted_at !== null} // Disable if canceled
                        className={`flex items-center justify-center align-middle font-semibold p-[6px] rounded-md shadow-md shadow-slate-400/50 
                        bg-yellow-500 text-white transform transition-transform duration-300 hover:scale-105
                      ${row.deleted_at ? 'opacity-50 cursor-not-allowed' : ''}`} // Reduce opacity & disable pointer
                    >
                        Rs. {row.totalFee}
                    </button>
                </div>
            ),
            sortable: false,
        },

        {
            name: 'View',
            cell: row => (
                <div className="flex items-center justify-center space-x-3">
                    <button
                        onClick={() => handleViewDetails(row)}
                        disabled={row.deleted_at !== null} // Disable if canceled
                        className={`flex items-center justify-center align-middle font-semibold p-[6px] rounded-md shadow-md shadow-slate-400/50
                        bg-blue text-white transform transition-transform duration-300 hover:scale-105 
                        ${row.deleted_at ? 'opacity-50 cursor-not-allowed' : ''}`}>
                        Details
                    </button>
                </div>
            ),
            sortable: false,
        },

        {
            name: 'Status',
            selector: row => (
                <select
                    value={row.status || 'unpaid'} // default to 'unpaid'
                    onChange={(e) => handleStatusChange(e, row.id)}
                    disabled={row.deleted_at !== null || row.status === 'paid'}
                    title={row.status === 'paid' ? 'Paid status cannot be changed' : ''}
                    style={{
                        backgroundColor: row.status === 'paid' ? '#97CE4F' : '#FF4A4A',
                        color: 'white',
                        padding: '5px 8px',
                        borderRadius: '5px',
                        border: 'none',
                        fontSize: '14px',
                        cursor: row.status === 'paid' ? 'not-allowed' : 'pointer',
                        opacity: row.status === 'paid' ? 0.7 : 1,
                    }}
                >
                    <option
                        value="unpaid"
                        style={{
                            backgroundColor: 'red',
                            padding: '10px',
                        }}
                    >
                        Unpaid
                    </option>
                    <option
                        value="paid"
                        style={{
                            backgroundColor: '#0DFF00BD',
                            padding: '10px',
                        }}
                    >
                        Paid
                    </option>
                </select>
            ),
            sortable: true,
        },
        {
            name: 'Action',
            cell: (row) => {
                const isCanceled = row.deleted_at !== null;
                const isPaid = row.status === 'paid';

                const printDisabled = isCanceled || !isPaid;

                return (
                    <div className="flex items-center justify-center space-x-3">

                        {/* Print Button */}
                        <button
                            onClick={() => handlePrintAppointment(row.id)}
                            disabled={printDisabled}
                            className={`flex items-center justify-center font-semibold gap-1 p-[6px] rounded-md 
                                shadow-md shadow-slate-400/50 bg-sky-600 text-white transition-transform duration-300 
                                ${printDisabled ? 'opacity-50 cursor-not-allowed' : 'hover:scale-105'}
                        `}
                        >
                            <BsFillPrinterFill className='text-sm' />
                        </button>

                        {/* Cancel OR Restore Button */}
                        {isCanceled ? (
                            /* Restore Button */
                            <button
                                onClick={() => handleRestoreAppointment(row.id)}
                                className="flex items-center justify-center font-semibold p-[6px] rounded-md 
                                    shadow-md shadow-slate-400/50 bg-white text-lime-500 transition-transform duration-300 
                                    hover:scale-105"
                            >
                                <MdRestore className='text-sm' />
                            </button>
                        ) : (
                            /* Cancel Button */
                            <button
                                onClick={() => handleCancelAppointment(row.id)}
                                className="flex items-center justify-center font-semibold p-[6px] rounded-md 
                                    shadow-md shadow-slate-400/50 bg-white text-red transition-transform duration-300 
                                    hover:scale-105"
                            >
                                <ImCancelCircle className='text-sm' />
                            </button>
                        )}
                    </div>
                );
            },
            sortable: false,
        }

    ];

    const handlePrintAppointment = (id) => {
        axios.get(`https://backend.amarasinghemedicare.com/appointment/appointments/print/${id}`, {
            responseType: 'blob', // PDF file download
        })
            .then((response) => {
                const file = new Blob([response.data], { type: 'application/pdf' });
                const fileURL = URL.createObjectURL(file);
                window.open(fileURL); // PDF open 
            })
            .catch((error) => {
                console.error('Error printing appointment:', error);
                toast.error('Error printing appointment.', {
                    position: "top-center",
                });
            });
    };

    const handleRestoreAppointment = async (appointmentId) => {
        try {
            const response = await fetch(`https://backend.amarasinghemedicare.com/appointment/appointments/restore/${appointmentId}`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (response.ok) {
                toast.success('Appointment restored successfully.');
                setAppointments(prev =>
                    prev.map(appt =>
                        appt.id === appointmentId
                            ? { ...appt, deleted_at: null }
                            : appt
                    )
                );
            } else {
                toast.error('Failed to restore appointment.');
            }
        } catch (error) {
            console.error('Error restoring appointment:', error);
        }
    };

    const handleCancelAppointment = async (appointmentId) => {
        // Show confirmation alert
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'Do you want to cancel this appointment?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, cancel it',
            cancelButtonText: 'No'
        });

        // If user clicked "No", stop here
        if (!result.isConfirmed) return;

        // Proceed with cancellation
        try {
            const response = await fetch(`https://backend.amarasinghemedicare.com/appointment/appointments/cancel/${appointmentId}`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (response.ok) {
                toast.success('Appointment canceled successfully.');
                setAppointments(prev =>
                    prev.map(appt =>
                        appt.id === appointmentId
                            ? { ...appt, deleted_at: new Date().toISOString() }
                            : appt
                    )
                );
                fetchAppointments();
            } else {
                toast.error("Failed to cancel appointment");
            }
        } catch (error) {
            console.error('Error canceling appointment:', error);
        }
    };

    const handleDeleteServices = async (serviceId) => {
        try {
            const response = await axios.delete(`https://backend.amarasinghemedicare.com/service/delete/${serviceId}`);

            if (response.status === 200) {
                toast.success("Service Deleted!");
                fetchServices(selectedId);
                fetchAppointments();
            } else {
                toast.error("Deleted Unsuccessful!");
            }
        } catch (error) {
            toast.error("Error in deleting service")
        }
    };

    const handleChanges = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.description || !formData.price) {
            toast.error("All fields are required!");
            return;
        }

        console.log(formData);

        const response = await axios.post('https://backend.amarasinghemedicare.com/service/create', formData)

        if (response.status === 200) {
            fetchServices(selectedId);
            setShowServiceInput(false);
            toast.success("Service added successfully!", {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            })
            fetchAppointments();
        }
    };

    const handleEditClick = (service) => {
        setEditingServiceId(service.id);
        setEditValues({ description: service.description, price: service.price });
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setEditValues(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmitEdits = async (serviceId) => {
        try {
            const response = await axios.put(`https://backend.amarasinghemedicare.com/service/update/${serviceId}`, editValues);

            if (response.status === 200) {
                toast.success("Updated success");
                setEditingServiceId(null);
                fetchServices(selectedId);
                fetchAppointments();
            } else {
                toast.error("Something went wrong!");
            }
        } catch (error) {
            toast.error("Error in updating service");
        }
    }

    useEffect(() => {
        if (selectedSchedule) {
            setEditFormData({
                scheduleID: selectedSchedule.id,
                start_time: selectedSchedule.start_time,
                end_time: selectedSchedule.end_time,
                doctor_fee: selectedSchedule.doctor_fee,
                patients: selectedSchedule.patients,
            });
        }
    }, [selectedSchedule]);

    useEffect(() => {
        setSelectedDoctor(doctor.id)
    }, []);

    return (
        <>
            <Toaster />
            <div className='flex items-center justify-between '>
                <div className='flex gap-4'>
                    <button
                        onClick={onCancel}
                        className="flex px-3 mb-4 items-center justify-center align-middle font-semibold  p-[6px] rounded-md shadow-md shadow-slate-400/50 outline-1  outline-slate-500 gap-1 bg-blue text-white hover:bg-green-500 transform transition-transform duration-300 hover:scale-105"
                    >

                        <IoArrowBackOutline />
                        Back
                    </button>
                </div>

                <div className='flex flex-row items-center justify-center gap-3 mb-4'>
                    <span className='font-semibold'>From :</span>
                    <input
                        type="date"
                        className="flex px-3 items-center justify-center align-middle font-semibold p-[6px] rounded-md shadow-md shadow-slate-400/50 outline-1 outline-slate-500 gap-1 bg-fontDark text-white hover:bg-green-500 transform transition-transform duration-300 hover:scale-105"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        placeholder="Start Date"
                    />

                    <span className='font-semibold'>To :</span>
                    <input
                        type="date"
                        className="flex px-3 items-center justify-center align-middle font-semibold p-[6px] rounded-md shadow-md shadow-slate-400/50 outline-1 outline-slate-500 gap-1 bg-fontDark text-white hover:bg-green-500 transform transition-transform duration-300 hover:scale-105"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        placeholder="End Date"
                    />

                    <button
                        onClick={() => {
                            setStartDate('');
                            setEndDate('');
                        }}
                        className="flex px-3 items-center justify-center align-middle font-semibold p-[6px] rounded-md shadow-md shadow-slate-400/50 outline-1 outline-slate-500 gap-1 bg-green text-white hover:bg-green-500 transform transition-transform duration-300 hover:scale-105"
                    >
                        Clear
                    </button>
                </div>

                {loading && <p>Loading appointments...</p>}
                {error && <p>{error}</p>}


            </div>
            <h2 className='mt-2 text-[20px] text-indigo-900 text-center font-bold'>
                Appointments for <span className='text-[23px] text-indigo-950'> Dr. {doctor.fullName}</span>
            </h2>
            {!showTable && (
                <DataTable
                    columns={columnsAppointments}
                    data={filteredAppointments}
                    fixedHeader
                    fixedHeaderScrollHeight="80vh"
                    className="data-table"
                    customStyles={customStyles}
                    pagination
                    paginationPerPage={rowPerPage}
                    paginationRowsPerPageOptions={[10, 20, 50, 100, 200]}
                    onChangeRowsPerPage={(newRowsPerPage) => { setRowPerPage(newRowsPerPage) }}
                />
            )}

            {showTable && appointments.length > 0 ? (
                <div>
                    <DataTable
                        columns={columnsAppointments}
                        data={filteredAppointments}
                        fixedHeader
                        fixedHeaderScrollHeight="80vh"
                        className="data-table"
                        customStyles={customStyles}
                        pagination
                        paginationPerPage={rowPerPage}
                        paginationRowsPerPageOptions={[10, 20, 50, 100, 200]}
                        onChangeRowsPerPage={(newRowsPerPage) => { setRowPerPage(newRowsPerPage) }}
                    />
                </div>
            ) : (
                <p></p>
            )}

            <Modal show={openModal} size="md" onClose={onCloseModal} popup>
                <Modal.Header className='bg-white' />
                <Modal.Body className='bg-white'>
                    <div className="space-y-6">
                        <h3 className="mb-6 text-xl font-medium text-gray-900">Add <span className='text-red'>New</span> Service</h3>
                    </div>
                    <div className='w-full'>
                        <div className="flex items-center justify-between w-full p-3 border rounded-xl border-blue">
                            <h1 className='text-sm'>Doctor Fee</h1>

                            <div className='flex items-center justify-center gap-3'>
                                <h1 className='font-semibold text-red text-sm'>Rs {selectedFee}</h1>
                                <button className="flex items-center justify-center align-middle font-semibold gap-1 p-[6px] rounded-md shadow-md shadow-slate-400/50 outline-1  outline-slate-500  bg-green text-white hover:bg-green-500 transform transition-transform duration-300 hover:scale-105">
                                    <FaEdit className='text-sm' />
                                </button>

                                <button className="flex items-center justify-center align-middle font-semibold p-[6px] rounded-md shadow-md shadow-slate-400/50 outline-1  outline-slate-500  bg-red text-white hover:bg-green-500 transform transition-transform duration-300 hover:scale-105">
                                    <MdDelete className='text-sm' />
                                </button>
                            </div>
                        </div>

                        {Array.isArray(details) && details.length > 0 ? (
                            details.map((service) => (
                                <div
                                    key={service.id}
                                    className="flex items-center justify-between w-full p-3 mt-2 border rounded-xl border-blue"
                                >
                                    {editingServiceId === service.id ? (
                                        <div className="flex flex-col gap-2 w-full">
                                            <input
                                                type="text"
                                                name="description"
                                                value={editValues.description}
                                                onChange={handleInputChange}
                                                className="p-1 border rounded"
                                                autoFocus
                                            />
                                            <input
                                                type="number"
                                                name="price"
                                                value={editValues.price}
                                                onChange={handleInputChange}
                                                className="p-1 border rounded"
                                            />

                                            <button
                                                onClick={() => handleSubmitEdits(service.id)}
                                                className="bg-green text-white px-4 py-1 rounded hover:bg-blue-600 transition"
                                            >
                                                Submit
                                            </button>
                                        </div>
                                    ) : (
                                        <>
                                            <div className="flex justify-between w-[78%]">
                                                <h1 className='text-sm'>{service.description}</h1>
                                                <h1 className="font-semibold text-red text-sm'">Rs {service.price}</h1>
                                            </div>

                                            <div className="flex items-center justify-center gap-3">
                                                <button
                                                    onClick={() => handleEditClick(service)}
                                                    className="flex items-center justify-center align-middle font-semibold gap-1 p-[6px] rounded-md shadow-md shadow-slate-400/50 outline-1 outline-slate-500 bg-green text-white hover:bg-green-500 transform transition-transform duration-300 hover:scale-105"
                                                >
                                                    <FaEdit className="text-sm" />
                                                </button>

                                                <button
                                                    onClick={() => handleDeleteServices(service.id)}
                                                    className="flex items-center justify-center align-middle font-semibold p-[6px] rounded-md shadow-md shadow-slate-400/50 outline-1 outline-slate-500 bg-red text-white hover:bg-red-500 transform transition-transform duration-300 hover:scale-105"
                                                >
                                                    <MdDelete className="text-sm" />
                                                </button>
                                            </div>
                                        </>
                                    )}
                                </div>
                            ))
                        ) : (
                            <p className="text-gray-500 italic mt-4 text-sm">No services found for this appointment.</p>
                        )}


                        <div className='flex items-center justify-center w-full p-3'>
                            <button onClick={() => setShowServiceInput(true)} className="text-sm flex items-center justify-center align-middle font-semibold gap-1 p-[6px] rounded-md shadow-md shadow-slate-400/50 outline-1  outline-slate-500  bg-blue text-white hover:bg-green-500 transform transition-transform duration-300 hover:scale-105">Add Service</button>
                        </div>

                        {showServiceInput && (
                            <div ref={serviceInputRef} className="w-full p-3 my-2 border rounded-xl border-green">
                                <form onSubmit={handleSubmit}>
                                    <div className='flex items-center justify-between gap-2'>
                                        <input placeholder='Enter Service' name='description' id='description' value={formData.description} onChange={handleChanges} type="text" className='w-[70%] h-8 rounded-md border border-gray-400 p-2 text-sm' />
                                        <input placeholder='Fee' type="text" value={formData.price} name='price' id='price' onChange={handleChanges} className='w-[30%] h-8 rounded-md border border-gray-400 p-2 text-sm' />
                                    </div>

                                    <div className='flex items-center justify-end w-full mt-2'>
                                        <button type='submit' className="w-[28%] flex text-sm font-light items-center justify-center align-middle gap-1 p-[6px] rounded-md shadow-md shadow-slate-400/50 outline-1  outline-slate-500  bg-green text-white hover:bg-green-500 transform transition-transform duration-300 hover:scale-105">Submit</button>
                                    </div>
                                </form>
                            </div>
                        )}

                        <div className="flex items-center justify-between w-full p-3 border rounded-xl border-red">
                            <h1 className='font-semibold text-sm'>Total Appointment Fee</h1>
                            <h1 className='font-semibold underline text-red underline-offset-2 decoration-double text-sm'>
                                Rs {selectedFee + (Array.isArray(details) ? details.reduce((total, service) => total + service.price, 0) : 0)}
                            </h1>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default EditAppointments;
